import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Building } from "src/app/app/building/building.model";
import { BuildingService } from "src/app/app/building/building.service";
import { Floor } from "src/app/app/building/floor/floor.model";
import { FloorService } from "src/app/app/building/floor/floor.service";
import { CompanyService } from "src/app/app/company/company.service";
import { EquipmentService } from "src/app/app/equipment/equipment.service";
import { InvitationService } from "src/app/app/invitation/invitation.service";
import { DictionaryService } from "src/app/dictionary";
import { Animations } from "src/app/_helpers/animations";
import { UserService } from "src/app/_services";
import { BookingService } from "src/app/_services/booking.service";
import { SpaceType } from "src/app/_types/space-type";
import { SelectButton } from "../../../select-buttons/select-buttons.model";
import { SpaceFilter } from "../../space-filter/space-filter.model";
import { SpaceFilterService } from "../../space-filter/space-filter.service";
import { SpaceDateFilterOptions } from "../space-date-filter.model";
import { SpaceDateFilterService } from "../space-date-filter.service";

@Component({
  selector: "app-space-date-filter-modal",
  templateUrl: "./space-date-filter-modal.component.html",
  styleUrls: ["./space-date-filter-modal.component.scss"],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class SpaceDateFilterModalComponent implements OnInit {
  constructor(
    public companyServ: CompanyService,
    public translate: TranslateService,
    public dictionaryServ: DictionaryService,
    public modalCtrl: ModalController,
    public invitationServ: InvitationService,
    public equipmentServ: EquipmentService,
    public bookingService: BookingService,
    public buildingServ: BuildingService,
    private floorServ: FloorService,
    public spaceFilterServ: SpaceFilterService,
    public spaceDateFilterService: SpaceDateFilterService,
    public userService: UserService
  ) {}

  showAllInvitations: boolean;

  showEquipment: boolean = false;

  showSpaceType: boolean = false;

  showBuildings: boolean = false;

  showReservationType: boolean = false;

  showLevel: boolean = false;

  parsedEquipments: SelectButton[] = [];

  startDate: any = new Date();

  floorList = [];

  buildingsList: Building[];

  @Input()
  page: string;

  @Input()
  spaceType: SpaceType;

  @Input()
  options: SpaceDateFilterOptions;

  @Input()
  equipmentListId: number[] = [];

  reservationTypeList = [
    {
      value: "me",
      key: this.translate.instant("SPACE.BOOK_FOR_ME"),
    },
    {
      value: "user",
      key: this.translate.instant("SPACE.BOOK_FOR_USER"),
    },
  ];

  async ngOnInit() {
    await this.buildingServ.loadBuildingsSync();
    this.markCheckedBuildings();
    

    if (this.buildingServ.buildings.length === 1) {
      this.spaceDateFilterService.filterModalFirstLoad = false;
      this.setFloorList(this.spaceFilterServ.filterDetails.buildingListId[0]);
    }

    if (this.spaceFilterServ.filterDetails.buildingListId.length > 0) {
      this.spaceFilterServ.filterDetails.buildingListId.forEach(
        (buildingListId) => {
          this.setFloorList(buildingListId);
        }
      );
    }

    await this.equipmentServ.loadEquipmentsSync(true, this.options.spaceType);
    this.parseEquipmentArray();

    this.spaceFilterServ.filterDetails = this.spaceFilterServ.filterDetails
      ? this.spaceFilterServ.filterDetails
      : new SpaceFilter();

    if (this.spaceDateFilterService.subtype == undefined) {
      this.spaceDateFilterService.subtype = this.dictionaryServ[
        this.options.subtypeSource
      ][0];
    }
  }

  onFilterSubtype(event) {
    const subtypeValue = event.detail.value.value;
    this.spaceDateFilterService.subtype = event.detail.value;
    this.spaceFilterServ.filterDetails.subtype = subtypeValue.toString();
  }

  onFilterBuilding(event, building) {
    if (event.detail.checked == true) {
      this.addFloorToList(building.id);
      this.spaceFilterServ.filterDetails.buildingList.push(building);
      this.spaceFilterServ.filterDetails.buildingListId.push(building.id);
    } else {
      this.spaceDateFilterService.filterLoadedFloors = this.spaceDateFilterService.filterLoadedFloors.filter(
        (el) => el.idBuilding !== building.id
      );

      this.spaceFilterServ.filterDetails.buildingList = this.spaceFilterServ.filterDetails.buildingList.filter(
        (el: Building) => el.id !== building.id
      );
      this.spaceFilterServ.filterDetails.buildingListId = this.spaceFilterServ.filterDetails.buildingListId.filter(
        (el) => el !== building.id
      );

      this.spaceFilterServ.filterDetails.floorList = this.spaceFilterServ.filterDetails.floorList.filter(
        (floor: Floor) => {
          // this.spaceFilterServ.filterDetails.floorListId = this.spaceFilterServ.filterDetails.floorListId.filter(
          //   (el: number) => el !== floor.id
          // );
          return floor.idBuilding !== building.id;
        }
      );
    }
  }
  onFilterFloor(event, floor) {
    if (event.detail.checked == true) {
      this.spaceFilterServ.filterDetails.floorList.push(floor);
      this.spaceFilterServ.filterDetails.floorListId.push(floor.id);
    } else {
      this.spaceFilterServ.filterDetails.floorList = this.spaceFilterServ.filterDetails.floorList.filter(
        (el: Floor) => el.id !== floor.id
      );
      this.spaceFilterServ.filterDetails.floorListId = this.spaceFilterServ.filterDetails.floorListId.filter(
        (el: number) => el !== floor.id
      );
    }
  }

  onFilterEquipment(event, equipment) {
    if (event.detail.checked == true) {
      this.spaceFilterServ.filterDetails.equipmentListId.push(equipment.value);
    } else {
      this.spaceFilterServ.filterDetails.equipmentListId = this.spaceFilterServ.filterDetails.equipmentListId.filter(
        (el: number) => el !== equipment.value
      );
    }
  }

  addFloorToList(buildingId: number) {
    this.floorServ
      .getFloors(buildingId, this.spaceType)
      .subscribe((floorList: Floor[]) => {
        this.spaceDateFilterService.filterLoadedFloors.push(...floorList);
      });
  }

  setFloorList(buildingId: number) {
    this.floorServ
      .getFloors(buildingId, this.spaceType)
      .subscribe((floorList: Floor[]) => {
        this.floorList = floorList;
        this.markCheckedFloors();
      });
  }

  parseEquipmentArray() {
    this.equipmentServ.equipments.forEach((el) => {
      let singleEquipment = {
        value: el.id,
        key: el.name,
        checked: this.spaceFilterServ.filterDetails?.equipmentListId.includes(
          el.id
        ),
      };
      this.parsedEquipments.push(singleEquipment);
    });
  }

  onFilterSpaces() {
    this.spaceFilterServ.reloadFilter(this.spaceFilterServ.filterDetails);
    this.onCloseModal();
  }

  markCheckedBuildings() {
    this.buildingServ.buildings = this.buildingServ.buildings.map(
      (building) => {
        return {
          ...building,
          checked: this.spaceFilterServ.filterDetails?.buildingListId.includes(
            building.id
          ),
        };
      }
    );
  }

  markCheckedFloors() {
    this.spaceDateFilterService.filterLoadedFloors = this.floorList.map(
      (floor) => {
        return {
          ...floor,
          checked: this.spaceFilterServ.filterDetails?.floorListId.includes(
            floor.id
          ),
        };
      }
    );
  }

  onClearFilters() {
    this.spaceFilterServ.filterDetails = new SpaceFilter();
    this.spaceDateFilterService.filterLoadedFloors = [];
    this.markCheckedBuildings();
    document.getElementById("standard").click(); // nie udało mi się zastosować viewChild
    this.spaceFilterServ.reloadFilter(this.spaceFilterServ.filterDetails);
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }
}
